'use strict';

const JsBarcode = require('jsbarcode');
const defaultOptions = {format: 'ean13', fontSize: 0, margin: 0, height: 100, width: 4};
/**
 * @function
 * @description Initializes the barcode generator
 */
exports.init = function (options) {
    if ($('#js-loyalty-id').length > 0) {
        const cardNumber = $('#js-loyalty-id').val();
        JsBarcode('#js-loyalty-image', cardNumber, options || defaultOptions);
    }

    if ($('.js-member-number').length > 0) {
        const cardNumber = $('.js-member-number').data('member-number');
        const config = {
            background: '#ffffff',
            flat: true,
            fontSize: 0,
            format: 'ean13',
            height: 36,
            lineColor: '#000000',
            margin: 0,
            width: 3
        };

        JsBarcode('.js-member-barcode', cardNumber, config);
    }
};
